import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ItemDisplayImage from '../../../../../components/line-item/components/item-image.component';
import messages from '../messages';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import style from '../style.module.less';

const ItemImageColumnId = 'itemImage';

const itemImageDataBuilder = (item) => {
  return { name: item.name, productThumbnailUrl: item.productThumbnailUrl };
};

const ItemImageCell = ({ cell }) => {
  return (
    <ItemDisplayImage
      className={style['item-image-container']}
      name={cell.value.name}
      productThumbnailUrl={cell.value.productThumbnailUrl}
    />
  );
};

ItemImageCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.shape({
      name: PropTypes.string,
      productThumbnailUrl: PropTypes.string,
    }),
  }).isRequired,
};

const createItemImageColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.itemImage} />,
  accessor: ItemImageColumnId,
  Cell: ItemImageCell,
  width: 1,
  className: style['justify-center'],
});

export { ItemImageColumnId, itemImageDataBuilder, createItemImageColumnDefinition };
